import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const RegulationIcon: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" fill="none" className={props.className}>
		<path
			fill="#BA9128"
			d="M3.426 16H16c-.003.93-.022 1.623-.113 2.17-.11.653-.31.998-.616 1.244-.307.246-.737.407-1.55.494-.837.09-1.946.092-3.536.092h-4.43c-1.59 0-2.7-.001-3.536-.092-.813-.087-1.243-.248-1.55-.494-.306-.246-.506-.591-.616-1.243a5.24 5.24 0 0 1-.022-.151c-.04-.291-.06-.437.066-.78.127-.344.181-.397.291-.505a2.62 2.62 0 0 1 1.285-.667c.29-.062.67-.068 1.753-.068Z"
		/>
		<path
			fill="#BA9128"
			d="M.727.733c.306-.308.734-.508 1.544-.618C3.105.002 4.209 0 5.793 0h4.414c1.584 0 2.688.002 3.522.115.81.11 1.238.31 1.544.618.305.308.504.74.613 1.557.112.84.114 1.955.114 3.552V16H3.426c-1.084 0-1.462.006-1.753.068-.513.11-.96.347-1.285.667-.11.108-.164.161-.291.505-.06.146-.094.302-.097.46V5.842C0 4.245.002 3.131.114 2.29.223 1.474.422 1.041.727.733Z"
			opacity=".4"
		/>
		<path
			fill="#BA9128"
			d="M3.25 5A.75.75 0 0 1 4 4.25h8a.75.75 0 1 1 0 1.5H4A.75.75 0 0 1 3.25 5ZM4 7.75a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5H4Z"
		/>
	</svg>
);
